import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Checkbox test card's body on the Test UI Components page: cs-checkbox enabled and disabled,
// checked and unchecked.
@Component({
  selector: 'cs-test-checkbox-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item-list-header data-test="checkbox-test-header">Checkbox test</cs-item-list-header>
      <cs-item>
        <cs-label>Enabled unchecked</cs-label>
        <cs-checkbox item-right [(checked)]="testCheckbox1" data-test="checkbox-enabled-unchecked"></cs-checkbox>
      </cs-item>
      <cs-item>
        <cs-label>Enabled checked</cs-label>
        <cs-checkbox item-right [(checked)]="testCheckbox2" data-test="checkbox-enabled-checked"></cs-checkbox>
      </cs-item>
      <cs-item>
        <cs-label>Disabled unchecked</cs-label>
        <cs-checkbox item-right [checked]="false" [disabled]="true" data-test="checkbox-disabled-unchecked"></cs-checkbox>
      </cs-item>
      <cs-item>
        <cs-label>Disabled checked</cs-label>
        <cs-checkbox item-right [checked]="true" [disabled]="true" data-test="checkbox-disabled-checked"></cs-checkbox>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestCheckboxCardComponent {
  testCheckbox1 = false;
  testCheckbox2 = true;
}
